<script setup lang="ts">
import { useChatStore } from "~/stores/chat/store";

const chatStore = useChatStore();
const { showChat } = storeToRefs(chatStore);
</script>

<template>
  <div class="flex items-center justify-between bg-[#9E23D2] p-3">
    <div>Chat</div>
    <div class="flex cursor-pointer items-center gap-4 text-xl">
      <font-awesome-icon :icon="['fas', 'xmark']" @click="showChat = false" />
    </div>
  </div>
</template>

<style scoped>
.dot {
  height: 8px;
  width: 8px;
  background-color: rgba(0, 230, 64, 1);
  border-radius: 50%;
  display: inline-block;
  position: absolute;
  right: -8px;
}
</style>
